import { render } from "./InfoPayment.vue?vue&type=template&id=ed775b2a&scoped=true"
import script from "./InfoPayment.vue?vue&type=script&lang=js"
export * from "./InfoPayment.vue?vue&type=script&lang=js"

import "./InfoPayment.vue?vue&type=style&index=0&id=ed775b2a&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed775b2a"]])

export default __exports__